<template>
  <el-row>
    <el-col :span="5">
      <div style="overflow-y: scroll;">
        <div id="leftTreeId" style="height: 775px;">
          <basic-container>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
            <el-tree
              class="filter-tree"
              :props="treeProps"
              node-key="id"
              ref="leftTreeRef"
              :load="lazyLoadLeftTree"
              :filter-node-method="filterNode"
              lazy
              @node-click="nodeClick"
            >
            </el-tree>
          </basic-container>
        </div>
      </div>
    </el-col>
    <el-col :span="19">
      <basic-container id="mainContainerId">
        <avue-crud
          :option="propertyOption"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
        >
          <template slot="menuLeft">
            <el-button
              type="primary"
              icon="el-icon-plus"
              v-if="permission.baseproperty_nodeAdd"
              @click="openNodeAddDialog"
            >
              新增节点
            </el-button>
            <el-button
              type="warning"
              icon="el-icon-edit"
              v-if="permission.baseproperty_nodeEdit"
              @click="openNodeEditDialog"
            >
              修改节点
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              plain
              v-if="permission.baseproperty_nodeDelete"
              @click="handleNodeDelete"
            >
              删除节点
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              style="margin-left: 25px;"
              v-if="permission.baseproperty_propertyAdd"
              @click="openPropertyAddDialog"
            >
              新增房间
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              plain
              v-if="permission.baseproperty_propertyDeleteBatch"
              @click="handlePropertyDelete"
            >
              删除房间
            </el-button>
          </template>

          <template slot="menu" slot-scope="scope">
            <el-button
              v-if="scope.row.dataPower >= 1"
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openPropertyViewDialog(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.dataPower >= 2 && permission.baseproperty_propertyEdit"
              type="text"
              icon="el-icon-edit"
              size="small"
              @click.native="openPropertyEditDialog(scope.row)"
              >修改</el-button
            >
            <el-button
              v-if="scope.row.dataPower >= 3 && permission.baseproperty_propertyDelete"
              type="text"
              icon="el-icon-delete"
              size="small"
              @click.native="rowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </avue-crud>

        <el-dialog
          :visible.sync="nodeAddShowDialogFlag"
          title="新增节点"
          :modal-append-to-body="false"
          destroy-on-close="true"
          @opened="nodeAddDialogOpened"
          @close="nodeAddDialog"
        >
          <div class="el-node-dialog-div">
            <avue-form
              ref="nodeAddFormRef"
              v-model="nodeAddForm"
              :option="nodeAddOption"
              @reset-change="nodeAddReset"
              @submit="nodeAddSubmit"
            >
              <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="parentObjectName"
                  ref="nodeAddParentNodeSelectRef"
                  placeholder="请选择，若不选择则为根节点"
                  clearable
                  @clear="nodeAddClearParentNodeSelect"
                  @click.native="nodeAddClickParentNodeSelect"
                >
                  <el-option :value="parentObjectName" :label="parentObjectName">
                    <el-tree
                      ref="nodeAddParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadNodeAddParentNodeTree"
                      lazy
                      @node-click="nodeAddParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitNodeAddDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="nodeEditShowDialogFlag"
          title="修改节点"
          :modal-append-to-body="false"
          destroy-on-close="true"
          @opened="nodeEditDialogOpened"
          @close="nodeEditDialog"
        >
          <div class="el-node-dialog-div">
            <avue-form
              ref="nodeEditFormRef"
              v-model="nodeEditForm"
              :option="nodeEditOption"
              @reset-change="nodeEditReset"
              @submit="nodeEditSubmit"
            >
            <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="nodeEditForm.parentObjectName"
                  ref="nodeEditParentNodeSelectRef"
                  placeholder="请选择，若不选择则为根节点"
                  clearable
                  @clear="nodeEditClearParentNodeSelect"
                  @click.native="nodeEditClickParentNodeSelect"
                >
                  <el-option :value="nodeEditForm.parentObjectName" :label="nodeEditForm.parentObjectName">
                    <el-tree
                      ref="nodeEditParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadNodeAddParentNodeTree"
                      lazy
                      @node-click="nodeEditParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitNodeEditDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="propertyAddShowDialogFlag"
          title="新增房间"
          :modal-append-to-body="false"
          destroy-on-close="true"
          @opened="propertyAddDialogOpened"
          @close="propertyAddDialog"
        >
          <div class="el-property-dialog-div">
            <avue-form
              ref="propertyAddFormRef"
              v-model="propertyAddForm"
              :option="propertyAddOption"
              @reset-change="propertyAddReset"
              @submit="propertyAddSubmit"
            >
              <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="parentObjectName"
                  ref="propertyAddParentNodeSelectRef"
                  placeholder="请选择，若不选择则为根节点"
                  clearable
                  @clear="propertyAddClearParentNodeSelect"
                  @click.native="propertyAddClickParentNodeSelect"
                >
                  <el-option :value="parentObjectName" :label="parentObjectName">
                    <el-tree
                      ref="propertyAddParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadPropertyAddParentNodeTree"
                      lazy
                      @node-click="propertyAddParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitPropertyAddDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="propertyEditShowDialogFlag"
          title="修改房间"
          :modal-append-to-body="false"
          destroy-on-close="true"
          @opened="propertyEditDialogOpened"
          @close="propertyEditDialog"
        >
          <div class="el-property-dialog-div">
            <avue-form
              ref="propertyEditFormRef"
              v-model="propertyEditForm"
              :option="propertyEditOption"
              @reset-change="propertyEditReset"
              @submit="propertyEditSubmit"
            >
              <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="propertyEditForm.parentObjectName"
                  ref="propertyEditFormParentNodeSelectRef"
                  placeholder="请选择，若不选择则为根节点"
                  clearable
                  @clear="propertyEditFormClearParentNodeSelect"
                  @click.native="propertyEditFormClickParentNodeSelect"
                >
                  <el-option :value="propertyEditForm.parentObjectName" :label="propertyEditForm.parentObjectName">
                    <el-tree
                      ref="propertyEditFormParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadNodeAddParentNodeTree"
                      lazy
                      @node-click="propertyEditFormParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitPropertyEditDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="propertyViewShowDialogFlag"
          title="查看"
          :modal-append-to-body="false"
          destroy-on-close="true"
          @opened="propertyViewDialogOpened"
          @close="propertyViewDialog"
        >
          <div class="el-property-dialog-div">
            <avue-form
              ref="propertyViewFormRef"
              v-model="propertyViewForm"
              :option="propertyViewOption"
              @reset-change="propertyViewReset"
            >
              <!--              <template slot-scope="scope" slot="menuForm">-->
              <!--                <el-button @click="quitPropertyViewDialog">退出</el-button>-->
              <!--              </template>-->
            </avue-form>
          </div>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  add,
  addNode,
  addProperty,
  getDetail,
  getDetailById,
  getList,
  getRoomInfo,
  getTreeChildrenNode,
  removeNode,
  removeProperty,
  update,
  updateNode,
  updateProperty,
  getBusinessDict
} from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';
import treeOption from './tree-option';
import propertyAddOption from './property-add-option';
import propertyOption from './property-option';
import propertyEditOption from './property-edit-option';
import nodeAddOption from './node-add-option';
import nodeEditOption from './node-edit-option';
import propertyViewOption from './property-view-option';
import { getOneDepartmentDetail } from '@/api/v4ward/department/department';

export default {
  data() {
    return {
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
        //节点数据权限
        dataPower: 'dataPower',
      },
      leftTreeRoot: {},
      leftTreeResolve: {},

      isNodeAddDialogFirstOpen: true,
      nodeAddParentNodeTreeRoot: {},
      nodeAddParentNodeTreeResolve: {},
      isPropertyAddDialogFirstOpen: true,
      propertyAddParentNodeTreeRoot: {},
      propertyAddParentNodeTreeResolve: {},

      //选中的树形节点信息
      treeTrackId: '',
      filterText: '',

      //选中的表格行信息
      tableTrackId: '',

      //父节点树结构相关信息
      parentId: '',
      parentObjectName: '',
      parentObjectType: 0,
      parentObjectTypeName: '',

      //窗口显示开关
      nodeAddShowDialogFlag: false,
      nodeEditShowDialogFlag: false,
      propertyAddShowDialogFlag: false,
      propertyEditShowDialogFlag: false,
      propertyViewShowDialogFlag: false,

      //form表单数据
      form: {},
      nodeAddForm: {},
      nodeEditForm: {},
      propertyAddForm: {},
      propertyEditForm: {},
      propertyViewForm: {},

      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],

      treeOption: treeOption,
      nodeAddOption: nodeAddOption,
      nodeEditOption: nodeEditOption,
      propertyOption: propertyOption,
      propertyAddOption: propertyAddOption,
      propertyEditOption: propertyEditOption,
      propertyViewOption: propertyViewOption,

      //页面数据
      treeData: [],
      data: [],

      //数据权限
      DATA_POWER_NULL: 0,
      DATA_POWER_VIEW: 1,
      DATA_POWER_VIEW_EDIT: 2,
      DATA_POWER_VIEW_EDIT_DEL: 3,
      tableUseType: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.baseproperty_add, false),
        viewBtn: this.vaildData(this.permission.baseproperty_view, false),
        delBtn: this.vaildData(this.permission.baseproperty_delete, false),
        editBtn: this.vaildData(this.permission.baseproperty_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {},
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
    'propertyAddForm.useType'() {
      if (this.propertyAddForm.useType === 4) {
        this.propertyAddOption.group[1].display = false;
        this.propertyAddOption.group[2].display = true;
        this.propertyAddOption.group[3].display = false;
        this.propertyAddForm.householdName = '公寓物业';
        this.propertyAddForm.householdLinkPhone = '123456';
      } else if (this.propertyAddForm.useType === 1 || this.propertyAddForm.useType === 5) {
        this.propertyAddOption.group[1].display = true;
        this.propertyAddOption.group[2].display = false;
        this.propertyAddOption.group[3].display = true;
        this.propertyAddForm.householdName = '';
        this.propertyAddForm.householdLinkPhone = '';
      } else {
        this.propertyAddOption.group[1].display = true;
        this.propertyAddOption.group[2].display = false;
        this.propertyAddOption.group[3].display = false;
        this.propertyAddForm.householdName = '';
        this.propertyAddForm.householdLinkPhone = '';
      }
    },
    'propertyEditForm.useType'() {
      if (this.propertyEditForm.useType === 4) {
        this.propertyEditOption.group[1].display = false;
        this.propertyEditOption.group[2].display = true;
        this.propertyEditOption.group[3].display = false;
        this.propertyEditForm.householdName = '公寓物业';
        this.propertyEditForm.householdLinkPhone = '123456';
      } else if (this.propertyEditForm.useType === 1 || this.propertyEditForm.useType === 5) {
        this.propertyEditOption.group[1].display = true;
        this.propertyEditOption.group[2].display = false;
        this.propertyEditOption.group[3].display = true;
      } else {
        this.propertyEditOption.group[1].display = true;
        this.propertyEditOption.group[2].display = false;
        this.propertyEditOption.group[3].display = false;
      }
    },
    'propertyViewForm.useType'() {
      if (this.propertyViewForm.useType === 4) {
        this.propertyViewOption.group[1].display = false;
        this.propertyViewOption.group[2].display = true;
        this.propertyViewOption.group[3].display = false;
      } else if (this.propertyViewForm.useType === 1 || this.propertyViewForm.useType === 5) {
        this.propertyViewOption.group[1].display = true;
        this.propertyViewOption.group[2].display = false;
        this.propertyViewOption.group[3].display = true;
      } else {
        this.propertyViewOption.group[1].display = true;
        this.propertyViewOption.group[2].display = false;
        this.propertyViewOption.group[3].display = false;
      }
    },
    'nodeAddForm.useType'() {
      if (this.nodeAddForm.useType === 3) {
        this.nodeAddOption.column[12].display = true;
        this.nodeAddOption.column[13].display = true;
        this.nodeAddOption.column[14].display = true;
      } else {
        this.nodeAddOption.column[12].display = false;
        this.nodeAddOption.column[13].display = false;
        this.nodeAddOption.column[14].display = false;
      }
    },
    'nodeEditForm.useType'() {
      if (this.nodeEditForm.useType === 3) {
        this.nodeEditOption.column[15].display = true;
        this.nodeEditOption.column[16].display = true;
        this.nodeEditOption.column[17].display = true;
      } else {
        this.nodeEditOption.column[15].display = false;
        this.nodeEditOption.column[16].display = false;
        this.nodeEditOption.column[17].display = false;
      }
    },
  },
  methods: {
    //懒加载树结构
    lazyLoadLeftTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.leftTreeRoot = node;
        this.leftTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadNodeAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.nodeAddParentNodeTreeRoot = node;
        this.nodeAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadPropertyAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.propertyAddParentNodeTreeRoot = node;
        this.propertyAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    //重新加载左侧树结构
    reloadLeftTree() {
      this.leftTreeRoot.childNodes = [];
      this.lazyLoadLeftTree(this.leftTreeRoot, this.leftTreeResolve);
    },
    reloadNodeAddParentNodeTree() {
      this.nodeAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadNodeAddParentNodeTree(
        this.nodeAddParentNodeTreeRoot,
        this.nodeAddParentNodeTreeResolve
      );
    },
    reloadPropertyAddParentNodeTree() {
      this.propertyAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadPropertyAddParentNodeTree(
        this.propertyAddParentNodeTreeRoot,
        this.propertyAddParentNodeTreeResolve
      );
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },

    //点击左侧树结构回调
    nodeClick(data) {
      this.treeTrackId = data.id;
      this.page.currentPage = 1;
      this.onLoad();
    },

    //打开窗口
    openNodeAddDialog() {
      this.nodeAddShowDialogFlag = true;
    },
    openNodeEditDialog() {
      if (this.treeTrackId) {
        let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
        if (node.data[this.treeProps.objectType] === 6) {
          this.$message.error('请不要编辑房间的节点信息!');
        } else if (node.data[this.treeProps.dataPower] < this.DATA_POWER_VIEW_EDIT) {
          this.$message.error('您所在的部门，没有编辑该节点的权限!');
        } else {
          this.nodeEditShowDialogFlag = true;
        }
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
      }
    },
    getCommunityGroupList(){
      getBusinessDict('community_group').then((res)=>{
        console.log("community_group===========>",res.data);
      });
    },
    openPropertyAddDialog() {
      this.propertyAddShowDialogFlag = true;
    },
    openPropertyEditDialog(row) {
      this.tableTrackId = row.id;
      this.propertyEditShowDialogFlag = true;
      if (row.useType === 4) {
        this.tableUseType = row.useType;
      }
    },
    openPropertyViewDialog(row) {
      this.tableTrackId = row.id;
      this.propertyViewShowDialogFlag = true;
      if (row.useType === 4) {
        this.tableUseType = row.useType;
      }
    },

    //窗口打开完成回调函数
    nodeAddDialogOpened() {
      this.$refs.nodeAddFormRef.resetForm();
      this.parentId = '';
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.parentObjectType = 0;
    },
    nodeEditDialogOpened() {
      this.$refs.nodeEditFormRef.resetForm();
      getDetailById({ id: this.treeTrackId }).then(({ data }) => {
        this.parentId = data.id;
        this.parentObjectName = data.parentObjectName;
        this.parentObjectTypeName = data.parentObjectTypeName;
        this.nodeEditForm.id = data.id;
        this.nodeEditForm.parentId = data.parentId;
        this.nodeEditForm.parentObjectName = data.parentObjectName;
        this.nodeEditForm.parentObjectTypeName = data.parentObjectTypeName;
        this.nodeEditForm.objectCode = data.objectCode;
        this.nodeEditForm.objectName = data.objectName;
        this.nodeEditForm.objectType = data.objectType;
        this.nodeEditForm.indexNum = data.indexNum;
        this.nodeEditForm.floorage = data.floorage;
        this.nodeEditForm.usableArea = data.usableArea;
        this.nodeEditForm.doorsNum = data.doorsNum;
        this.nodeEditForm.useDesc = data.useDesc;
        this.nodeEditForm.envDesc = data.envDesc;

        this.nodeEditForm.useType = data.useType;
        this.nodeEditForm.totalArea = data.totalArea;
        this.nodeEditForm.usedArea = data.usedArea;
        this.nodeEditForm.availableArea = data.availableArea;
        this.nodeEditForm.communityGroup = data.communityGroup;
      });
    },
    propertyAddDialogOpened() {
      this.$refs.propertyAddFormRef.resetForm();
      this.parentId = '';
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.propertyAddForm.objectTypeName = '房间';
    },
    propertyEditDialogOpened() {
      this.$refs.propertyEditFormRef.resetForm();
      //如果修改的房屋性质是公寓就赋值
      if (this.tableUseType === 4) {
        getOneDepartmentDetail({ propertyId: this.tableTrackId }).then(({ data }) => {
          this.propertyEditForm.bedCapacity = data[0].bedCapacity;
          this.propertyEditForm.bedUsing = data[0].bedUsing;
          this.tableUseType = '';
        });
      }else {
        this.propertyEditForm.bedUsing = 0;
      }
      getRoomInfo({ id: this.tableTrackId }).then(({ data }) => {
        this.propertyEditForm.objectFullName = data.objectFullName;
        this.parentId = data.id;
        this.parentObjectName = data.parentObjectName;
        this.parentObjectTypeName = data.parentObjectTypeName;
        this.propertyEditForm.id = data.id;
        this.propertyEditForm.parentId = data.parentId;
        this.propertyEditForm.parentObjectName = data.parentObjectName;
        this.propertyEditForm.parentObjectTypeName = data.parentObjectTypeName;
        this.propertyEditForm.objectType = data.objectType;
        this.propertyEditForm.objectCode = data.objectCode;
        this.propertyEditForm.objectName = data.objectName;
        this.propertyEditForm.shortCode = data.shortCode;
        this.propertyEditForm.indexNum = data.indexNum;
        this.propertyEditForm.roomName = data.roomName;
        this.propertyEditForm.floorage = data.floorage;
        this.propertyEditForm.usableArea = data.usableArea;
        this.propertyEditForm.roomLayout = data.roomLayout;
        this.propertyEditForm.loftArea = data.loftArea;
        this.propertyEditForm.parkingArea = data.parkingArea;
        this.propertyEditForm.additionArea = data.additionArea;
        this.propertyEditForm.roomStatus = data.roomStatus;
        this.propertyEditForm.useType = data.useType;
        this.propertyEditForm.roomOrientations = data.roomOrientations;
        this.propertyEditForm.useDesc = data.useDesc;
        this.propertyEditForm.roomType = data.roomType;
        this.propertyEditForm.householdName = data.householdName;
        this.propertyEditForm.householdSex = data.householdSex;
        this.propertyEditForm.householdLinkPhone = data.householdLinkPhone;
        this.propertyEditForm.householdIdCard = data.householdIdCard;
        this.propertyEditForm.householdEmail = data.householdEmail;
        this.propertyEditForm.householdQQ = data.householdQQ;
        this.propertyEditForm.householdAddress = data.householdAddress;
        this.propertyEditForm.remark1 = data.remark1;

        this.propertyEditForm.totalArea = data.totalArea;
        this.propertyEditForm.usedArea = data.usedArea;
        this.propertyEditForm.availableArea = data.availableArea;
      });
    },
    propertyViewDialogOpened() {
      this.$refs.propertyViewFormRef.resetForm();
      //如果查看的房屋性质是公寓就赋值
      if (this.tableUseType === 4) {
        getOneDepartmentDetail({ propertyId: this.tableTrackId }).then(({ data }) => {
          this.propertyViewForm.bedCapacity = data[0].bedCapacity;
          this.propertyViewForm.bedUsing = data[0].bedUsing;
          this.tableUseType = '';
        });
      }
      getRoomInfo({ id: this.tableTrackId }).then(({ data }) => {
        this.parentId = data.id;
        this.parentObjectName = data.parentObjectName;
        this.parentObjectTypeName = data.parentObjectTypeName;
        this.propertyViewForm.objectFullName = data.objectFullName;
        this.propertyViewForm.id = data.id;
        this.propertyViewForm.parentId = data.parentId;
        this.propertyViewForm.parentObjectName = data.parentObjectName;
        this.propertyViewForm.parentObjectTypeName = data.parentObjectTypeName;
        this.propertyViewForm.objectType = data.objectType;
        this.propertyViewForm.objectCode = data.objectCode;
        this.propertyViewForm.objectName = data.objectName;
        this.propertyViewForm.shortCode = data.shortCode;
        this.propertyViewForm.indexNum = data.indexNum;
        this.propertyViewForm.roomName = data.roomName;
        this.propertyViewForm.floorage = data.floorage;
        this.propertyViewForm.usableArea = data.usableArea;
        this.propertyViewForm.roomLayout = data.roomLayout;
        this.propertyViewForm.loftArea = data.loftArea;
        this.propertyViewForm.parkingArea = data.parkingArea;
        this.propertyViewForm.additionArea = data.additionArea;
        this.propertyViewForm.roomStatus = data.roomStatus;
        this.propertyViewForm.useType = data.useType;
        this.propertyViewForm.roomOrientations = data.roomOrientations;
        this.propertyViewForm.useDesc = data.useDesc;
        this.propertyViewForm.roomType = data.roomType;
        this.propertyViewForm.householdName = data.householdName;
        this.propertyViewForm.householdSex = data.householdSex;
        this.propertyViewForm.householdLinkPhone = data.householdLinkPhone;
        this.propertyViewForm.householdIdCard = data.householdIdCard;
        this.propertyViewForm.householdEmail = data.householdEmail;
        this.propertyViewForm.householdQQ = data.householdQQ;
        this.propertyViewForm.householdAddress = data.householdAddress;
        this.propertyViewForm.remark1 = data.remark1;

        this.propertyViewForm.totalArea = data.totalArea;
        this.propertyViewForm.usedArea = data.usedArea;
        this.propertyViewForm.availableArea = data.availableArea;
      });
    },
    // 初始化父节点树结构
    initNodeAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isNodeAddDialogFirstOpen) {
        this.reloadNodeAddParentNodeTree();
      } else {
        this.isNodeAddDialogFirstOpen = false;
      }
    },
    initPropertyAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isPropertyAddDialogFirstOpen) {
        this.reloadPropertyAddParentNodeTree();
      } else {
        this.isPropertyAddDialogFirstOpen = false;
      }
    },
    initSelectTreeStyle() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },

    //点击窗口中的父节点选择框回调函数
    nodeAddClickParentNodeSelect() {},
    propertyAddClickParentNodeSelect() {},
    // 窗口中父节点树节点点击回调
    nodeAddParentNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];

      this.parentObjectType = node[this.treeProps.objectType];
      this.parentObjectTypeName = nodeTypeName;
      this.parentObjectName = nodeTitle;

      if (this.nodeAddShowDialogFlag) {
        this.$refs.nodeAddParentNodeSelectRef.blur();
        this.nodeAddForm.parentId = nodeId;
        this.nodeAddForm.parentObjectTypeName = nodeTypeName;
      }
    },
    //编辑节点
    nodeEditParentNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];

      this.nodeEditForm.parentObjectType = node[this.treeProps.objectType];
      this.nodeEditForm.parentObjectTypeName = nodeTypeName;
      this.nodeEditForm.parentObjectName = nodeTitle;

      if (this.nodeEditShowDialogFlag) {
        this.$refs.nodeEditParentNodeSelectRef.blur();
        this.nodeEditForm.parentId = nodeId;
        this.nodeEditForm.parentObjectTypeName = nodeTypeName;
      }
    },
    //编辑房产
    propertyEditFormParentNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];

      this.propertyEditForm.parentObjectType = node[this.treeProps.objectType];
      this.propertyEditForm.parentObjectTypeName = nodeTypeName;
      this.propertyEditForm.parentObjectName = nodeTitle;

      if (this.propertyEditShowDialogFlag) {
        this.$refs.propertyEditFormParentNodeSelectRef.blur();
        this.propertyEditForm.parentId = nodeId;
        this.propertyEditForm.parentObjectTypeName = nodeTypeName;
      }
    },
    propertyAddParentNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];

      this.parentObjectName = nodeTitle;

      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
        this.propertyAddForm.parentId = nodeId;
        this.propertyAddForm.parentObjectTypeName = nodeTypeName;
      }
    },

    //重置窗口数据
    nodeAddReset() {
      this.initNodeAddParentNodeTree();
      this.nodeAddClearParentNodeSelect();
    },
    nodeEditReset() {
      this.nodeEditForm.id = this.treeTrackId;
      this.nodeEditForm.parentId = this.parentId;
      this.nodeEditForm.parentObjectName = this.parentObjectName;
      this.nodeEditForm.parentObjectTypeName = this.parentObjectTypeName;
    },
    propertyAddReset() {
      this.initPropertyAddParentNodeTree();
    },
    propertyEditReset() {
      this.propertyEditForm.id = this.tableTrackId;
      this.propertyEditForm.parentId = this.parentId;
      this.propertyEditForm.parentObjectName = this.parentObjectName;
      this.propertyEditForm.parentObjectTypeName = this.parentObjectTypeName;
    },

    // 清除父节点树选项
    nodeAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.nodeAddForm.parentObjectTypeName = '';
      this.clearTreeStyle(this.nodeAddShowDialogFlag, 'nodeAddParentNodeTree');
      this.$emit('getValue', null);
    },
    //编辑节点清楚
    nodeEditClearParentNodeSelect() {
      this.nodeEditForm.parentObjectTypeName=''
      this.nodeEditForm.parentObjectName=''
      this.nodeEditForm.parentId=''
      this.clearTreeStyle(this.nodeEditShowDialogFlag, 'nodeEditParentNodeTree');
      this.$emit('getValue', null);
    },
    nodeEditClickParentNodeSelect() {},
    propertyEditFormClearParentNodeSelect() {
      this.propertyEditForm.parentObjectTypeName=''
      this.propertyEditForm.parentObjectName=''
      this.propertyEditForm.parentId=''
      this.clearTreeStyle(this.propertyEditShowDialogFlag, 'propertyEditNodeTree');
      this.$emit('getValue', null);
    },
    propertyEditFormClickParentNodeSelect() {},
    propertyAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.parentObjectTypeName = '';
      this.propertyAddForm.parentObjectTypeName = '';
      this.clearTreeStyle(this.propertyAddShowDialogFlag, 'nodeEditParentNodeTreeRef');
      this.$emit('getValue', null);
    },
    clearTreeStyle(showDialogFlag, treeId) {
      if (showDialogFlag) {
        let allNode = document.querySelectorAll('#' + treeId + ' .el-tree-node');
        allNode.forEach((element) => element.classList.remove('is-current'));
      }
    },

    nodeAddSubmit(form, done) {
      if (form.objectType === 6) {
        this.$message.error('新增节点时，类型请不要选择房间!');
        done();
        return;
      }

      if (this.parentObjectType >= form.objectType) {
        this.$message.error(
          '新增节点的类型 <' +
            this.getObjectTypeNameByKey(form.objectType) +
            '> 不能挂载在 <' +
            this.getObjectTypeNameByKey(this.parentObjectType) +
            '> 下面！'
        );
        done();
        return;
      }

      if (form.useType === 3) {
        //商业
        if (form.objectType != 5) {
          this.$message.error(
            '新增节点的类型 <' +
              this.getObjectTypeNameByKey(form.objectType) +
              '> 不能匹配房屋性质 <商业>！'
          );
          done();
          return;
        }

        if (Number(form.totalArea) < Number(form.usedArea) + Number(form.availableArea)) {
          this.$message.error('新增节点租赁信息的总面积小于已用面积和可用面积之和！');
          done();
          return;
        }
      }

      this.$refs.nodeAddFormRef.validate((valid) => {
        if (valid) {
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }

          addNode(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();

              this.$message.success('操作成功!');

              this.nodeAddShowDialogFlag = false;
              this.$refs.nodeAddFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    nodeEditSubmit(form, done) {
      if (form.useType === 3) {
        //商业
        if (form.objectType != 5) {
          this.$message.error(
            '修改节点的类型 <' +
              this.getObjectTypeNameByKey(form.objectType) +
              '> 不能匹配房屋性质 <商业>！'
          );
          done();
          return;
        }
        if (Number(form.totalArea) < Number(form.usedArea) + Number(form.availableArea)) {
          this.$message.error('修改节点租赁信息的总面积小于已用面积和可用面积之和！');
          done();
          return;
        }
      }

      this.$refs.nodeEditFormRef.validate((valid) => {
        if (valid) {
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }

          updateNode(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.nodeEditShowDialogFlag = false;

              this.$refs.nodeEditFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyAddSubmit(form, done) {
      if (form.useType === 1 || form.useType === 5) {
        //出租屋，商铺
        if (Number(form.totalArea) < Number(form.usedArea) + Number(form.availableArea)) {
          this.$message.error('新增房间租赁信息的总面积小于已用面积和可用面积之和！');
          done();
          return;
        }
      }

      this.$refs.propertyAddFormRef.validate((valid) => {
        if (valid) {
          //占用铺位默认为0
          form.bedUsing = 0;
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }
          addProperty(form, this.query).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.propertyAddShowDialogFlag = false;
              this.$refs.propertyAddFormRef.resetForm();
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyEditSubmit(form, done) {
      if (form.useType === 1 || form.useType === 5) {
        //出租屋，商铺
        if (Number(form.totalArea) < Number(form.usedArea) + Number(form.availableArea)) {
          this.$message.error('修改房间租赁信息的总面积小于已用面积和可用面积之和！');
          done();
          return;
        }
      }
      this.$refs.propertyEditFormRef.validate((valid) => {
        if (valid) {
          if (this.vdui.isEmpty(form.parentId)) {
            form.parentId = '0';
          }
          updateProperty(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.propertyEditShowDialogFlag = false;
              this.$refs.propertyEditFormRef.resetForm();
              this.bedCapacity = 0;
              this.bedUsing = 0;
              this.editIsShow = false;
              done();
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    propertyViewDialog() {
      this.propertyViewShowDialogFlag = false;
      this.$refs.propertyViewFormRef.resetForm();
      this.tableUseType = '';
    },
    nodeAddDialog() {
      this.nodeAddShowDialogFlag = false;
      this.$refs.nodeAddFormRef.resetForm();
    },
    nodeEditDialog() {
      this.nodeEditShowDialogFlag = false;
      this.$refs.nodeEditFormRef.resetForm();
    },
    propertyAddDialog() {
      this.propertyAddShowDialogFlag = false;
      this.$refs.propertyAddFormRef.resetForm();
      this.bedCapacity = 0;
      this.bedUsing = 0;
      this.isShow = false;
    },
    propertyEditDialog() {
      this.propertyEditShowDialogFlag = false;
      this.$refs.propertyEditFormRef.resetForm();
    },
    quitNodeAddDialog() {
      this.nodeAddShowDialogFlag = false;
      this.$refs.nodeAddFormRef.resetForm();
    },
    quitNodeEditDialog() {
      this.nodeEditShowDialogFlag = false;
      this.$refs.nodeEditFormRef.resetForm();
    },
    quitPropertyAddDialog() {
      this.propertyAddShowDialogFlag = false;
      this.$refs.propertyAddFormRef.resetForm();
      this.bedCapacity = 0;
      this.bedUsing = 0;
      this.isShow = false;
    },
    quitPropertyEditDialog() {
      this.propertyEditShowDialogFlag = false;
      this.$refs.propertyEditFormRef.resetForm();
      this.bedCapacity = 0;
      this.bedUsing = 0;
      this.tableUseType = '';
      this.editIsShow = false;
    },

    rowSave(row, loading, done) {
      add(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success('操作成功!');
        },
        (error) => {
          loading();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success('操作成功!');
        },
        (error) => {
          loading();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeProperty({ ids: row.id });
        })
        .then(() => {
          this.reloadLeftTree();
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleNodeDelete() {
      if (this.treeTrackId) {
        let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
        if (node.data[this.treeProps.objectType] === 6) {
          this.$message.error('请不要编辑房间的节点信息!');
          return;
        } else if (node.data[this.treeProps.dataPower] < this.DATA_POWER_VIEW_EDIT_DEL) {
          this.$message.error('您所在的部门，没有删除该节点的权限!');
          return;
        }
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
        return;
      }

      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeNode({ id: this.treeTrackId });
        })
        .then(() => {
          this.reloadLeftTree();
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    handlePropertyDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }

      let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
      if (node.data[this.treeProps.dataPower] < this.DATA_POWER_VIEW_EDIT_DEL) {
        this.$message.error('您所在的部门，没有删除该小区下房间的权限!');
        return;
      }

      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeProperty({ ids: this.ids });
        })
        .then(() => {
          this.reloadLeftTree();
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;

      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, treeTrackId: this.treeTrackId },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
        this.setTreeHeight();
      });
    },
    setTreeHeight() {
      let mainHeight = document.getElementById('mainContainerId').offsetHeight;
      document.getElementById('leftTreeId').style.height = mainHeight - 10 + 'px';
    },
    getObjectTypeNameByKey(key) {
      switch (key) {
        case 1:
          return '小区';
        case 2:
          return '建筑体';
        case 3:
          return '楼栋';
        case 4:
          return '单元';
        case 5:
          return '楼层';
        case 6:
          return '房间';
        default:
          return '未识别类型';
      }
    },
  },
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 500px;
  overflow: auto;
}

.el-property-dialog-div {
  height: inherit;
  overflow: auto;
}
</style>
